import { defineMessages } from 'react-intl';

export default defineMessages({
  notice: {
    id: 'pages.GoogleRecaptchaNotice.notice',
    defaultMessage: 'This site is protected by reCAPTCHA and the Google {privacyPolicy} and {termsOfService} apply.',
  },
  privacyPolicy: {
    id: 'pages.GoogleRecaptchaNotice.privacyPolicy',
    defaultMessage: 'Privacy Policy',
  },
  termsOfService: {
    id: 'pages.GoogleRecaptchaNotice.termsOfService',
    defaultMessage: 'Terms of Service',
  },
});
